import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { LandingFooter, LandingHeader } from "@/components/landing/LandingChrome";
import { LegalText } from "@/components/landing/LegalText";
import { api } from "@/lib/api";

export const LEGAL_LINKS = [["mentions-legales", "Mentions légales"], ["cgu", "Conditions d'utilisation"], ["cgv", "Conditions de vente"], ["confidentialite", "Confidentialité"]];

export default function Legal() {
  const { slug } = useParams();
  const { data, isError } = useQuery({ queryKey: ["legal", slug], queryFn: () => api.get(`/public/legal/${slug}`).then((r) => r.data) });
  useEffect(() => { window.scrollTo(0, 0); if (data) document.title = `${data.title} — CASHMY`; }, [data]);
  return (
    <div className="min-h-screen bg-background" data-testid="legal-page">
      <LandingHeader />
      <main className="mx-auto max-w-3xl space-y-6 px-5 py-12">
        <nav className="flex flex-wrap gap-2">{LEGAL_LINKS.map(([s, l]) => (
          <Link key={s} to={`/legal/${s}`} className={`rounded-full border px-3 py-1.5 text-xs font-bold transition-colors ${s === slug ? "border-primary bg-primary text-primary-foreground" : "border-border hover:bg-muted"}`} data-testid={`legal-tab-${s}`}>{l}</Link>))}</nav>
        {isError ? <p data-testid="legal-error">Page introuvable.</p> : !data ? <p className="text-muted-foreground">Chargement…</p> : (
          <article className="space-y-4"><h1 className="text-3xl font-extrabold sm:text-4xl" data-testid="legal-title">{data.title}</h1><LegalText content={data.content} /></article>)}
      </main>
      <LandingFooter />
    </div>
  );
}
